import { useState } from 'react';
import { useCart } from '../contexts/CartContext';

const useCheckoutForm = () => {
  const { cart } = useCart();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postcode: '',
    country: 'BG',
    notes: ''
  });
  const [orderError, setOrderError] = useState('');

  // Дефиниране на специалните идентификатори за методите на доставка
  const SPECIAL_SHIPPING_INSTANCE_ID = 2; // Econt
  const SPECIAL_SHIPPING_INSTANCE_ID_2 = 3; // Speedy
  const PICKUP_SHIPPING_INSTANCE_ID = 4; // Вземане от магазин
  const ADDRESS_SHIPPING_INSTANCE_ID = 5; // Доставка до адрес

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Помощна функция за получаване на правилното поле за адрес според метода на доставка
  const getAddressField = (field, shippingData) => {
    const { 
      selectedOffice, 
      selectedCityId, 
      cities, 
      selectedSpeedy2Office 
    } = shippingData;

    if (cart.shippingMethod?.instance_id === SPECIAL_SHIPPING_INSTANCE_ID) {
      if (field === 'address') return selectedOffice ? (selectedOffice.address || selectedOffice.office_address || '') : '';
      if (field === 'city') return selectedOffice ? (cities.find(c => String(c.city_id) === String(selectedCityId))?.name || '') : '';
      if (field === 'postcode') {
        // Проверка на всички възможни имена на полета за пощенски код в данните за офиса
        if (selectedOffice) {
          // Опитване на всички възможни имена на полета за пощенски код
          return selectedOffice.post_code || 
                 selectedOffice.postCode || 
                 selectedOffice.postcode || 
                 selectedOffice.zip_code || 
                 selectedOffice.zipCode || 
                 // Получаване на пощенски код от града, ако офисът няма такъв
                 (cities.find(c => String(c.city_id) === String(selectedCityId))?.post_code) || 
                 (cities.find(c => String(c.city_id) === String(selectedCityId))?.postCode) || 
                 '';
        }
        return '';
      }
      if (field === 'country') return 'BG';
      return '';
    }
    
    if (cart.shippingMethod?.instance_id === SPECIAL_SHIPPING_INSTANCE_ID_2) {
      if (field === 'address') {
        return selectedSpeedy2Office ? selectedSpeedy2Office.fullAddr : '';
      }
      if (field === 'city') {
        return selectedSpeedy2Office ? selectedSpeedy2Office.region : '';
      }
      if (field === 'postcode') {
        return selectedSpeedy2Office ? selectedSpeedy2Office.postCode : '';
      }
      if (field === 'country') return 'BG';
      return '';
    }
    
    if (cart.shippingMethod?.instance_id === PICKUP_SHIPPING_INSTANCE_ID) {
      if (field === 'address') return 'ул. Княз Борис 98';
      if (field === 'city') return 'Стара Загора';
      if (field === 'postcode') return '6000';
      if (field === 'country') return 'BG';
      return '';
    }
    
    if (cart.shippingMethod?.instance_id === ADDRESS_SHIPPING_INSTANCE_ID) {
      return formData[field];
    }
    
    return formData[field];
  };

  // Валидиране на формуляра според избрания метод на доставка
  const validateForm = (selectedPayment, shippingData) => {
    const { 
      selectedCityId, 
      selectedOffice, 
      filteredOffices,
      selectedSiteId,
      selectedSpeedy2Office,
      filteredSpeedy2Offices
    } = shippingData;

    if (!selectedPayment) {
      setOrderError('Моля, изберете метод на плащане');
      return false;
    }

    if (!cart.shippingMethod) {
      setOrderError('Моля, изберете метод на доставка');
      return false;
    }

    // Валидиране на метод за доставка 2 (Econt)
    if (cart.shippingMethod.instance_id === SPECIAL_SHIPPING_INSTANCE_ID) {
      if (!selectedCityId) {
        setOrderError('Моля, изберете населено място за доставка.');
        return false;
      }
      
      if (!selectedOffice) {
        // Проверка дали има налични офиси
        if (filteredOffices.length === 0) {
          setOrderError('Няма налични офиси за избраното населено място. Моля, изберете друго населено място.');
        } else {
          setOrderError('Моля, изберете офис за доставка.');
        }
        return false;
      }
    }
    
    // Валидиране на метод за доставка 3 (Speedy)
    if (cart.shippingMethod.instance_id === SPECIAL_SHIPPING_INSTANCE_ID_2) {
      if (!selectedSiteId) {
        setOrderError('Моля, изберете населено място за доставка.');
        return false;
      }
      
      if (!selectedSpeedy2Office) {
        // Проверка дали има налични офиси
        if (filteredSpeedy2Offices.length === 0) {
          setOrderError('Няма налични офиси за избраното населено място. Моля, изберете друго населено място.');
        } else {
          setOrderError('Моля, изберете офис за доставка.');
        }
        return false;
      }
    }
    
    // Валидиране на метод за доставка 5 (Доставка до адрес)
    if (cart.shippingMethod.instance_id === ADDRESS_SHIPPING_INSTANCE_ID) {
      if (!formData.address) {
        setOrderError('Моля, въведете адрес за доставка.');
        return false;
      }
      
      if (!formData.city) {
        setOrderError('Моля, въведете населено място за доставка.');
        return false;
      }
      
      if (!formData.postcode) {
        setOrderError('Моля, въведете пощенски код за доставка.');
        return false;
      }
    }

    setOrderError('');
    return true;
  };

  return {
    formData,
    setFormData,
    handleInputChange,
    getAddressField,
    validateForm,
    orderError,
    setOrderError,
    // Константи
    SPECIAL_SHIPPING_INSTANCE_ID,
    SPECIAL_SHIPPING_INSTANCE_ID_2,
    PICKUP_SHIPPING_INSTANCE_ID,
    ADDRESS_SHIPPING_INSTANCE_ID
  };
};

export default useCheckoutForm; 